<div class="{{ class }}">
  <h1 [ngClass]="class + '__title text-primary-color'">
    {{ textData.promotionBanner.headline }}
    <span class="text-header-underlined text-dark-grey">
      {{ textData.promotionBanner.headlineSecond }}
    </span>
  </h1>
  <p [innerHTML]="updatedDescription" class="mt-4"></p>
</div>
